import { z } from "zod";
import type { CreateContactAttemptDto } from "@myapp/contract";
import { fromDatetimeLocal, toDatetimeLocal } from "../../../shared/helpers/date";

/** The API accepts a few minutes ahead (a phone clock a bit fast); the form says the same. */
const FUTURE_TOLERANCE_MS = 5 * 60 * 1000;

export const attemptFormSchema = z
  .object({
    note: z.string().max(200, "Höchstens 200 Zeichen"),
    date: z.string().min(1, "Datum angeben"),
    time: z.string().min(1, "Uhrzeit angeben"),
  })
  .superRefine((values, ctx) => {
    const iso = fromDatetimeLocal(`${values.date}T${values.time}`);
    if (!iso) return;
    if (new Date(iso).getTime() > Date.now() + FUTURE_TOLERANCE_MS) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["time"],
        message: "Der Zeitpunkt liegt in der Zukunft",
      });
    }
  });

export type AttemptFormValues = z.infer<typeof attemptFormSchema>;

/** Prefilled with „jetzt", because most attempts are recorded right after the call. */
export function defaultAttemptValues(now: Date = new Date()): AttemptFormValues {
  const [date, time] = toDatetimeLocal(now).split("T");
  return { note: "", date, time };
}

/** Date and time are two inputs on screen and one instant on the wire. */
export function toCreateDto(values: AttemptFormValues): CreateContactAttemptDto {
  const attemptedAt = fromDatetimeLocal(`${values.date}T${values.time}`);
  if (!attemptedAt) throw new Error("Ungültiger Zeitpunkt");
  return { attemptedAt, note: values.note.trim() };
}
